module.exports = __webpack_public_path__ + "static/media/telegramm.86746e69.svg";